import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'Que comprend exactement le site à partir de 69€/mois ?',
    a: 'Vous obtenez un site complet et personnalisé : design sur-mesure, responsive mobile, formulaire de contact ou de devis, optimisation SEO de base, hébergement sécurisé, et livraison en 7 jours maximum (48h en moyenne). Tout est inclus dans l\'abonnement mensuel : maintenance, sauvegardes, et support.',
  },
  {
    q: 'Comment modifier mon site après livraison ?',
    a: 'Toutes les modifications passent par notre équipe. Il vous suffit de nous contacter par email ou téléphone. Nous traitons vos demandes rapidement, généralement sous 24h. C\'est simple : vous décrivez ce que vous souhaitez, on s\'en charge.',
  },
  {
    q: 'Que se passe-t-il si je ne suis pas satisfait du résultat ?',
    a: 'Votre satisfaction est notre priorité absolue. Nous travaillons avec vous jusqu\'à ce que le résultat vous convienne parfaitement. Des ajustements gratuits sont inclus avant la livraison finale. Aucun paiement n\'est demandé tant que vous n\'êtes pas satisfait.',
  },
  {
    q: 'Comment se passe le paiement ?',
    a: 'Le paiement de création se fait à la livraison, une fois que vous êtes satisfait du résultat. L\'abonnement mensuel démarre ensuite. Nous proposons aussi le paiement en plusieurs fois et des tarifs réduits avec un engagement de 6 ou 12 mois.',
  },
  {
    q: 'Puis-je garder mon nom de domaine existant ?',
    a: 'Bien sûr ! Nous pouvons utiliser votre domaine existant ou vous en procurer un nouveau. Tout le côté technique (DNS, hébergement, SSL) est géré par notre équipe. Vous n\'avez rien à faire de votre côté.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-slate-50/60">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-start">
          {/* Colonne gauche */}
          <div className="lg:col-span-2">
            <p className="text-xs font-bold text-emerald-500 uppercase tracking-[4px] mb-3">Questions fréquentes</p>
            <h2 className="text-2xl sm:text-4xl font-black text-slate-900 mb-5 leading-tight">
              Tout Ce Que{' '}
              <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">
                Vous Voulez Savoir
              </span>
            </h2>
            <p className="text-sm sm:text-base text-slate-500 leading-relaxed mb-8">
              Des questions ? Consultez nos réponses ci-dessous ou contactez-nous directement.
            </p>

            <div className="space-y-3">
              <a
                href="tel:+33651872435"
                className="flex items-center gap-3 bg-white rounded-xl px-5 py-4 border border-slate-100 hover:border-emerald-200 transition-colors cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-50 flex-shrink-0 group-hover:bg-emerald-100 transition-colors">
                  <i className="ri-phone-fill text-emerald-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-slate-900">Nous appeler</p>
                  <p className="text-xs text-slate-400">06 51 87 24 35</p>
                </div>
                <i className="ri-arrow-right-s-line text-slate-300 ml-auto"></i>
              </a>
              <Link
                to="/demande-devis"
                className="flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-xl px-5 py-4 cursor-pointer hover:shadow-lg hover:shadow-emerald-500/25 transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/20 flex-shrink-0">
                  <i className="ri-file-text-fill text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-white">Devis gratuit</p>
                  <p className="text-xs text-emerald-100">Réponse sous 24h</p>
                </div>
                <i className="ri-arrow-right-s-line text-white/60 ml-auto"></i>
              </Link>
            </div>
          </div>

          {/* Accordéon */}
          <div className="lg:col-span-3">
            <div className="space-y-0">
              {faqs.map((faq, i) => (
                <div key={i} className="border-b border-slate-200 last:border-b-0">
                  <button
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    className="w-full flex items-center justify-between py-5 sm:py-6 text-left cursor-pointer group"
                    aria-expanded={openIndex === i}
                  >
                    <h3 className={`text-sm sm:text-base font-bold pr-4 transition-colors leading-snug ${openIndex === i ? 'text-emerald-600' : 'text-slate-800 group-hover:text-emerald-600'}`}>
                      {faq.q}
                    </h3>
                    <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                      openIndex === i ? 'bg-emerald-500' : 'bg-white border-2 border-slate-200'
                    }`}>
                      <i className={`text-lg transition-transform duration-300 ${
                        openIndex === i ? 'ri-subtract-line text-white rotate-0' : 'ri-add-line text-slate-500'
                      }`}></i>
                    </div>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-60 pb-5 sm:pb-6' : 'max-h-0'
                  }`}>
                    <p className="text-sm sm:text-base text-slate-500 leading-relaxed pr-12">
                      {faq.a}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
